// Join sidebar sections
(() => {
  const sidebars = [...document.querySelectorAll('.section-sidebar')];

  if (sidebars.length < 2) {
    return;
  }

  firstSidebar = sidebars.shift();
  firstSidebarLinksHolder = firstSidebar.querySelector('ul.widget__links');
  firstSidebarCollapsibleElements = firstSidebar.querySelector('collapsible-elements');

  if (!firstSidebarLinksHolder) {
    return;
  }

  sidebars.forEach((sidebar) => {
    sidebar.querySelectorAll('ul.widget__links li').forEach((link) => {
      link.querySelector('button')?.classList.remove('is-selected');
      firstSidebarLinksHolder.appendChild(link)
    });

    [...sidebar.querySelector('collapsible-elements')?.children || []].forEach((collapsibleElement) => {
      firstSidebarCollapsibleElements.appendChild(collapsibleElement);
    });

    sidebar.closest('.shopify-section').remove();
  });
})();